import React from 'react';
import { useWeather } from '../../lib/hooks/useCaptainOverview';
import { WeatherRepository } from '../../lib/repositories/WeatherRepository';

export const CompactWeatherWidget: React.FC = () => {
  const { data: weather, isLoading, error } = useWeather();

  if (isLoading || error || !weather) {
    return null;
  }

  return (
    <div className="compact-weather-widget">
      {weather.map((location) => (
        <div key={location.city} className="compact-weather-item">
          <span className="compact-weather-city">{location.city}</span>
          <img 
            src={WeatherRepository.getIconUrl(location.icon)}
            alt={location.description}
            className="compact-weather-icon"
          />
          <span className="compact-weather-temp">{location.temperature}°</span>
        </div>
      ))}
    </div>
  );
};
